import Vue from 'vue'
import VueResource from 'vue-resource'
import mixins from '../mixins.js'
import datePicker from '../../component/dccore-form/datePicker.vue'
import moment from 'moment'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import SimpleSingleselect from '../../component/simple-form/singleselect.vue'
import Swal from 'sweetalert2'
import * as toastr from 'toastr'
import { DRIVERS_REPORT_DEFAULT_COUNTRY, tag } from '../../const/common'

require('bootstrap')

if ($('#drivers_report').length) {
  Vue.use(VueResource)
  new Vue({
    el: '#drivers_report',
    components: {
      datePicker,
      Singleselect,
      SimpleSingleselect
    },
    mixins: [mixins],
    data: {
      countries: [],
      countryId: null,
      routes: [],
      buttonsDisabled: false,
      route: null,
      dateFrom: moment().locale('pl').format('YYYY-MM-DD'),
      dateTo: moment().locale('pl').format('YYYY-MM-DD'),
      emails: [],
      error: null,
      form: {
        options: {
          errors: {},
        }
      },
    },
    computed: {
      routesByCountry() {
        let routes = []
        this.routes.forEach(value => {
          if (value.name === Translator.trans('route.drivers_report.all') || value.countryId === this.countryId) {
            routes.push(value)
          }
        })
        return routes
      },
      isXmlButtonVisible() {
        let selected = this.countries.find(item => {
          return this.countryId === item.id
        })
        return !(selected && selected.systemValue === tag.routeCountry.GERMANY)
      },
    },
    watch: {
      dateFrom: function() {
        this.validateDate()
        this.getRoutes()
      },
      dateTo: function() {
        this.validateDate()
        this.getRoutes()
      }
    },
    mounted: function () {
      this.getRoutes()
      this.getCountries()
    },
    methods: {
      validateDate() {
        const toDate = new Date(this.dateTo)
        const fromDate = new Date(this.dateFrom)
        if (toDate < fromDate) {
          this.buttonsDisabled = true
          this.form.options.errors = { dateTo: Translator.trans('form.errors.date_to_must_be_equal_greater') }
        } else {
          this.buttonsDisabled = false
          this.form.options.errors = {}
        }
      },
      getRoutes() {
        let url = Routing.generate('api_get_routes_by_date', { from: this.dateFrom,
          to: this.dateTo,
          context: 'dropdown' })
        this.$http.get(url).then(response => {
          this.routes = [{ id:null,
            name:Translator.trans('route.drivers_report.all') }].concat(response.data)
        })
      },
      getCountries() {
        let url = Routing.generate('api_get_tags', { 'type': 'route_country' })
        this.$http.get(url).then(response => {
          this.countries = response.data
          this.countryId = this.getDefaultCountryId()
        })
      },
      generatePdf() {
        $('#generate_report_pdf').button('loading')
        let route = Routing.generate('drivers_report_generate_pdf', {
          dateFrom: this.dateFrom,
          dateTo: this.dateTo,
          countryId: this.countryId,
          routeId: this.route
        })
        this.$http.get(route).then( () => {
          $('#generate_report_pdf').button('reset')
          Swal.fire({
            title: 'Raport kierowców',
            text: 'Zlecono wygenerowanie raportu. Gdy będzie gotowy, otrzymasz maila z linkiem do pobrania.',
            icon: 'success',
            confirmButtonText: 'OK'
          })
        }, response => {
          $('#generate_report_pdf').button('reset')
          this.handleAjaxError(response)
        })
      },
      generateXls() {
        $('#generate_report_xlsx').button('loading')
        let route = Routing.generate('drivers_report_generate_xls', {
          dateFrom: this.dateFrom,
          dateTo: this.dateTo,
          countryId: this.countryId,
          routeId: this.route
        })
        this.$http.get(route).then( () => {
          $('#generate_report_xlsx').button('reset')
          Swal.fire({
            title: 'Raport kierowców',
            text: 'Zlecono wygenerowanie raportu. Gdy będzie gotowy, otrzymasz maila z linkiem do pobrania.',
            icon: 'success',
            confirmButtonText: 'OK'
          })
        }, response => {
          $('#generate_report_xlsx').button('reset')
          this.handleAjaxError(response)
        })
      },
      downloadXmlOld() {
        this.downloadXml(true, '#btn-download-xml-old')
      },
      downloadXml(old = false, btnId = '#btn-download-xml', sot = false) {
        $(btnId).button('loading')
        const data = {
          dateFrom: this.dateFrom,
          dateTo: this.dateTo,
          countryId: this.countryId,
          routeId: this.route,
        }

        if (old === true) {
          data.old = 1
        } else if (sot === true) {
          data.sot = 1
        }

        let route = Routing.generate('drivers_report_generate_xml', data)
        this.$http.get(route).then(response => {
          const fileName = response.data.fileName
          let route = Routing.generate('drivers_report_xml_exists', {
            fileName: fileName
          })
          this.$http.get(route).then(() => {
            window.open(Routing.generate('drivers_report_download_xml', {
              fileName: fileName
            }), '_blank')
          }, () => {
            toastr.error(Translator.trans('global.messages.fetch_problem'))
          })
          $(btnId).button('reset')
        }, () => {
          toastr.error(Translator.trans('global.messages.fetch_problem'))
          $(btnId).button('reset')
        })
      },
      showAcceptanceModal() {
        $('#acceptModal').modal()
      },
      sendEmails() {
        let self = this
        $('#acceptModal').modal('hide')
        $('#btn-driver-emails').button('loading')
        this.$http.get(Routing.generate('drivers_report_send_emails', {
          dateFrom: this.dateFrom,
          dateTo: this.dateTo,
          countryId: this.countryId,
          routeId: this.route,
        })).then(response => {
          self.error = response.data.error
          self.emails = response.data
          $('#btn-driver-emails').button('reset')
          $('#checkModal').modal()
        })
      },
      closePopup() {
        $('#checkModal').modal('hide')
      },
      closeAcceptPopup() {
        $('#acceptModal').modal('hide')
      },
      getDefaultCountryId() {
        let defaultCountry = this.countries.find((item) => {
          return item.systemValue === DRIVERS_REPORT_DEFAULT_COUNTRY
        })
        return defaultCountry.id
      },
    },
  })
}
